import * as Yup from 'yup';

const celRegExp = /^\(\d{2}\) \d{5}-\d{4}$/;
const telRegExp = /^\(\d{2}\) \d{4}-\d{4}|\(\d{2}\) \d{5}-\d{4}$/

export const ScheduleContactsValidation = Yup.object().shape({
    tel: Yup.string().matches(telRegExp, 'Verifique se o telefone está correto, com 11 dígitos').required('O telefone é obrigatório'),
    cel: Yup.string().matches(celRegExp, 'Verifique se o celular está correto, com 11 dígitos').required('O celular é obrigatório'),
    email: Yup.string().email('Verifique se o e-mail está correto, com @ e pontoo').required('O email é obrigatório').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Insira um e-mail válido e correto'),
})
